import { Injectable } from '@angular/core';
import {  Subject } from 'rxjs';
import { PnpClientService } from 'src/pnpframework/public-api';
import { OktaAuthorizationService } from "./okta-auth-service";
@Injectable({
  providedIn: 'root',
})
export class AzureAuthorizationService {

  public restrictAccess  = new Subject();
  public notifyUserInfo = new Subject();
  constructor(private _pnpClientService: PnpClientService,
              private _oktaAuthService: OktaAuthorizationService
              ) {
  }

  public getAzureAccessToken(): any {
      return this._pnpClientService.getTokens()
      .then(async tokens => {
        await this._oktaAuthService.setAuthoringContent();
        return {
          access_token: tokens.accessToken,
          id_token: tokens.idToken
        }
      });
  }

  getAzureUserProfile(): any {
      return this._pnpClientService.getAzureUser();
  }

}
